import './index.css';
import { jsx } from 'react/jsx-runtime';
import { MultiUpload } from './MultiUpload.js';
import { SingleUpload } from './SingleUpload.js';
import 'react-dropzone';
import 'classnames';
import '@hh.ru/magritte-ui-spacing';
import './FileViewWithPreview.js';
import './FileView.js';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-avatar';
import '@hh.ru/magritte-ui-divider';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-loader';
import './FileName.js';
import './utils.js';
import './useFilePreview.js';
import 'react';
import './Placeholder.js';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-typography';
import './useDropActions.js';
import './useDropButtons.js';
import './upload-D19YV3Gb.js';

const Upload = ({ multiple, noDragEventsBubbling = true, ...uploadProps }) => {
    if (multiple) {
        return jsx(MultiUpload, { noDragEventsBubbling: noDragEventsBubbling, ...uploadProps });
    }
    return jsx(SingleUpload, { noDragEventsBubbling: noDragEventsBubbling, ...uploadProps });
};

export { Upload };
//# sourceMappingURL=Upload.js.map
